import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const Pennsylvania = () => {
  return (
    <StatePropertyTaxPage
      stateName="Pennsylvania"
      processDescription="Property owners may appeal their assessment by filing with the county board of assessment appeals within 40 days of the mailing of notice of assessment. Appeals should include evidence supporting the property owner's claimed fair market value."
      noticeOfValueMailed="March"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in March following county reassessments or annual updates."
      valuationAsOfDate="January 1"
      valuationAsOfDateExplanation="Pennsylvania assesses property as of January 1 each year, though counties may conduct reassessments at different intervals. This assessment date ensures consistent timing when reassessments occur."
      deadlineExplanation="Property owners have 40 days from the mailing of the assessment notice to file appeals with the county board of assessment appeals. This typically results in an April or May deadline."
    />
  );
};

export default Pennsylvania;